class ShopifyCart {
  constructor(config) {
    this.config = config;

    if (this.config.showDrawer) {
      this.drawer = document.querySelector(this.config.drawerSelector);
      this.drawerCartList = document.querySelector(
        this.config.drawerCartListSelector
      );
    }

    // Ensure window.cartData is an object
    if (typeof window.cartData !== "object" || window.cartData === null) {
      window.cartData = {};
    }

    this.cartProxy = new Proxy(window.cartData, {
      set: (target, key, value) => {
        target[key] = value;
        this.updateDrawer(false);
        if (document.querySelector("#cart-body")) {
          this.updateCart(false);
        }
        return true;
      },
    });

    this.addToCartProxy = new Proxy(window.cartData, {
      set: (target, key, value) => {
        target[key] = value;
        this.updateDrawer(true);
        if (document.querySelector("#cart-body")) {
          this.updateCart(true);
        }
        return true;
      },
    });

    if (this.config.showDrawer) {
      this.addDrawerEventListeners();
    }

    this.initializeCart();
    this.addProductFormListener();

    // Add Safari-specific cart helper
    this.setupSafariCartHelper();
  }

  addDrawerEventListeners() {
    const openDrawerButton = document.querySelector(
      this.config.openDrawerButtonSelector
    );
    const closeDrawerButton = document.querySelector(
      this.config.closeDrawerButtonSelector
    );
    const closeDrawerBackdrop = document.querySelector(
      this.config.closeDrawerBackdropSelector
    );

    openDrawerButton.addEventListener("click", () => {
      this.drawer.classList.add("active");
    });
    closeDrawerButton.addEventListener("click", () => {
      this.drawer.classList.remove("active");
    });
    closeDrawerBackdrop.addEventListener("click", () => {
      this.drawer.classList.remove("active");
    });

    const removeItems = document.querySelectorAll(
      this.config.removeItemSelector
    );
    removeItems.forEach((item) => {
      item.addEventListener("click", (e) => this.removeItem(e));
    });

    const incrementItems = document.querySelectorAll(
      this.config.incrementItemSelector
    );
    const decrementItems = document.querySelectorAll(
      this.config.decrementItemSelector
    );

    incrementItems.forEach((item) => {
      item.addEventListener("click", (e) => this.incrementItem(e));
    });

    decrementItems.forEach((item) => {
      item.addEventListener("click", (e) => this.decrementItem(e));
    });
  }

  updateDrawer(action) {
    fetch(window.Shopify.routes.root + "?sections=section-drawer")
      .then((resp) => resp.json())
      .then((res) => {
        const parser = new DOMParser();
        const el = parser.parseFromString(res["section-drawer"], "text/html");
        const newDrawerContent = el.getElementById("drawer").cloneNode(true);

        const drawerElement = document.querySelector(
          this.config.drawerSelector
        );
        drawerElement.parentNode.replaceChild(newDrawerContent, drawerElement);

        this.drawer = newDrawerContent;
      })
      .then(() => {
        this.addDrawerEventListeners();
        if (document.querySelector(this.config.drawerCounterSelector)) {
          this.updateCartCounter();
        }
        if (action) {
          this.drawer.classList.add("active");
        }
      });
  }

  // responseHandler(status) {
  // 	// Add to cart responses elements
  // 	const success = document.getElementById('add-to-cart-200');
  // 	const stockError = document.getElementById('add-to-cart-422');
  // 	const generalError = document.getElementById('add-to-cart-500');
  // 	const noproductError = document.getElementById('add-to-cart-0');

  // 	//console.log(status);
  // 	if (status === 422) {
  // 		stockError.style.display = 'block';
  // 		setTimeout(() => {
  // 			stockError.style.display = 'none';
  // 		}, 5000);
  // 	} else if (status === 200) {
  // 		success.style.display = 'block';
  // 		success.style.opacity = 0;
  // 		setTimeout(() => {
  // 			success.style.display = 'none';
  // 		}, 5000);
  // 	} else if (status === 500) {
  // 		generalError.style.display = 'block';
  // 		setTimeout(() => {
  // 			generalError.style.display = 'none';
  // 		}, 5000);
  // 	} else if (status === 0) {
  // 		noproductError.style.display = 'block';
  // 		setTimeout(() => {
  // 			noproductError.style.display = 'none';
  // 		}, 2500);
  // 	}

  // 	return;
  // }

  updateCart(action) {
    fetch(window.Shopify.routes.root + "?sections=main-cart")
      .then((resp) => resp.json())
      .then((res) => {
        const parser = new DOMParser();
        const el = parser.parseFromString(res["main-cart"], "text/html");
        const newCartContent = el.getElementById("cart-body").cloneNode(true);

        const cartBodyElement = document.querySelector(
          this.config.cartBodyElement
        );
        cartBodyElement.parentNode.replaceChild(
          newCartContent,
          cartBodyElement
        );

        this.cart = newCartContent;
      })
      .then(() => {
        this.addDrawerEventListeners();
        if (document.querySelector(this.config.drawerCounterSelector)) {
          this.updateCartCounter();
        }
      });
  }

  updateCartCounter() {
    const cartCounter = document.querySelector(
      this.config.drawerCounterSelector
    );
    const cartItemCount = this.cartProxy.cart.item_count;
    if (cartItemCount > 0) {
      cartCounter.classList.add("active");
    } else {
      cartCounter.classList.remove("active");
    }
  }

  initializeCart() {
    window.onload = () => {
      fetch(window.Shopify.routes.root + "cart.js")
        .then((response) => response.json())
        .then((result) => {
          this.cartProxy.cart = result;
        });
    };
  }

  async addCart(e, variantId) {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    let formData = {
      items: [
        {
          id:
            variantId ||
            (e &&
            e.target &&
            e.target.querySelector &&
            e.target.querySelector('[name="id"]:checked')
              ? e.target.querySelector('[name="id"]:checked').value
              : e &&
                e.target &&
                e.target.querySelector &&
                e.target.querySelector('select[name="id"]')
              ? e.target.querySelector('select[name="id"]').value
              : null),
          quantity: 1,
        },
      ],
      attributes: {},
    };

    // More robust variant ID check
    if (!formData.items[0].id) {
      console.error("No variant ID found");
      if (document.querySelector(this.config.selectSizeMessage)) {
        document
          .querySelector(this.config.selectSizeMessage)
          .classList.add("active");
      }
      return;
    }

    if (document.querySelector(this.config.selectSizeMessage)) {
      document
        .querySelector(this.config.selectSizeMessage)
        .classList.remove("active");
    }

    console.log("Adding to cart with variant ID:", formData.items[0].id);

    try {
      const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.status === 200) {
        const cartResponse = await fetch(
          window.Shopify.routes.root + "cart.js"
        );
        const result = await cartResponse.json();
        this.addToCartProxy.cart = result;
        this.updateDrawer(true);
      }
    } catch (error) {
      console.error("Error adding to cart:", error);
    }
  }

  async removeItem(event) {
    let formData = { id: event.target.dataset.variant, quantity: 0 };

    fetch(window.Shopify.routes.root + "cart/change.js", {
      method: "POST",
      headers: {
        "content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        fetch(window.Shopify.routes.root + "cart.js")
          .then((response) => response.json())
          .then((result) => {
            this.addToCartProxy.cart = result;
          });
      })
      .catch((error) => {
        console.error(error);
      });
  }

  async incrementItem(event) {
    let formData = {
      id: event.target.dataset.variant,
      quantity: Number(event.target.dataset.qty) + 1,
    };

    fetch(window.Shopify.routes.root + "cart/change.js", {
      method: "POST",
      headers: {
        "content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        if (response.status === 200 || response.status === 422) {
          console.log(response.status);
          fetch(window.Shopify.routes.root + "cart.js")
            .then((response) => response.json())
            .then((result) => {
              this.addToCartProxy.cart = result;
            });
        } else {
          console.log(response.status);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  async decrementItem(event) {
    let formData = {
      id: event.target.dataset.variant,
      quantity: Number(event.target.dataset.qty) - 1,
    };

    fetch(window.Shopify.routes.root + "cart/change.js", {
      method: "POST",
      headers: {
        "content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        fetch(window.Shopify.routes.root + "cart.js")
          .then((response) => response.json())
          .then((result) => {
            this.addToCartProxy.cart = result;
          });
      })
      .catch((error) => {
        console.error(error);
      });
  }

  addProductFormListener() {
    const forms = document.querySelectorAll(this.config.productFormSelector);
    forms.forEach((form) => {
      form.addEventListener("submit", (event) => {
        this.addCart(event);
      });
    });

    document.querySelectorAll(".js-quick-add-button").forEach((el) => {
      el.addEventListener("click", async (event) => {
        await this.addCart(event, event.target.dataset.id);
        const form = event.target.closest("form");
        if (form) {
          form.classList.remove("active");
        }
      });
    });

    // Add global methods for quick add modal - support both methods for compatibility
    window.quickAddToCart = (variantId) => {
      this.addCart(null, variantId);
    };

    window.safariQuickAddToCart = (variantId) => {
      return window.safariAddToCart(variantId);
    };
  }

  setupSafariCartHelper() {
    // Add direct method for Safari compatibility
    window.safariAddToCart = async (variantId) => {
      if (!variantId) {
        console.error("No variant ID provided");
        return;
      }

      console.log("Safari helper adding to cart:", variantId);

      const formData = {
        items: [
          {
            id: variantId,
            quantity: 1,
          },
        ],
        attributes: {},
      };

      try {
        const response = await fetch(
          window.Shopify.routes.root + "cart/add.js",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
          }
        );

        const responseData = await response.json();
        console.log("Safari cart response:", responseData);

        if (response.status === 200) {
          // Get updated cart data
          const cartResponse = await fetch(
            window.Shopify.routes.root + "cart.js"
          );
          const result = await cartResponse.json();
          this.addToCartProxy.cart = result;
          this.updateDrawer(true);
          return true;
        } else {
          console.error("Error adding to cart:", responseData);
          return false;
        }
      } catch (error) {
        console.error("Safari cart error:", error);
        return false;
      }
    };
  }
}

document.addEventListener("click", function (event) {
  const activeForm = document.querySelector(
    ".snippet__product-item--quick-add--form.active"
  );
  const clickedInsideProductItem = event.target.closest(
    ".snippet__product-item"
  );

  if (
    activeForm &&
    (!clickedInsideProductItem ||
      clickedInsideProductItem !== activeForm.closest(".snippet__product-item"))
  ) {
    activeForm.classList.remove("active");
  }
});

// Configuration object
const config = {
  showDrawer: true,
  drawerSelector: "#drawer",
  cartBodyElement: "#cart-body",
  drawerCounterSelector: "#toggle-drawer-button span",
  drawerCartListSelector: "#drawer-cart-list",
  openDrawerButtonSelector: "#toggle-drawer-button",
  closeDrawerButtonSelector: "#close-drawer-button",
  closeDrawerBackdropSelector: "#close-drawer-backdrop",
  removeItemSelector: ".remove-item-form",
  incrementItemSelector: "#increment-item-form",
  decrementItemSelector: "#decrement-item-form",
  productFormSelector: "#product-form",
  selectSizeMessage: ".form__actions-message",
};

// Initialize the ShopifyCart class with the config object
const sCart = new ShopifyCart(config);

// Make cart instance available globally
window.sCart = sCart;
